import React, { ReactNode} from "react";
import { FilterItem } from "../../../../../types/filters";
import useFilters from "../../../../../hooks/useFilters";
import { CentsPalette } from "../../../../../utils/colors";

interface Props {
  filter: FilterItem,
  closePopup: () => void
  filterTable: () => void
  children: ReactNode
}

const GenericFilter: React.FC<Props> = ({ filter, closePopup, filterTable, children }) => {
  const { removeFilter, getActiveFilters } = useFilters()

  const handleRemoveFilter = () => {
    removeFilter(filter.id ?? '')
    filterTable()
  }
  
  return (
    <div className={`${filter.id} flex flex-col items-start gap-2 p-5 w-fit bg-cents-grey rounded-2xl transition-all duration-300`}>
      <p className={`text-xs font-semibold pl-4`}>{filter.label}</p>
      
      <div className="filter-body flex items-start gap-2">
        {children}
        <button disabled={!(filter.id && filter.id in getActiveFilters())} className={`remove-button h-10 w-10 flex justify-center items-center border-2 border-cents-purple disabled:border-gray-400 group rounded-2xl`} onClick={handleRemoveFilter}>
          <svg className="h-3 w-3" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4L36 36M36 4L4 36" className="group-disabled:stroke-gray-400" stroke={CentsPalette.cents_purple} strokeLinecap="round" stroke-linejoin="round" strokeWidth="8"/>
          </svg>
        </button>
      </div>
    </div>
  )
}

export default GenericFilter;